export default "__VITE_ASSET__I41167HW__"